import { FacultyProfile } from '../components/FacultyProfile';
import { SectionWrapper } from '../components/SectionWrapper';

import aiInnovatorsUrl from '@/images/ai_innovators.png';
import styles from './AIInnovatorsSection.module.css';

const faculty = [
  {
    initials: 'ZS',
    name: 'Prof. Zrinka Stahuljak',
    role: 'UCLA Comparative Literature',
  },
  {
    initials: 'EL',
    name: 'Elizabeth Landers',
    role: 'UCLA Humanities',
  },
  {
    initials: 'AK',
    name: 'Prof. Alex Kusenko',
    role: 'UCLA Physics & Astronomy',
  },
] as const;

export function AIInnovatorsSection() {
  return (
    <SectionWrapper background="white" data-testid="ai-section-innovators">
      <div className={styles.section}>
        <div className={styles.copy}>
          <p className={styles.eyebrow}>RECOGNITION</p>
          <h2 className={styles.title}>
            Three Kudu educators selected as AI Innovators at ASU+GSV.
          </h2>
          <p className={styles.body}>
            The AI Show at ASU+GSV is the largest gathering of edtech AI
            innovators in the world. Three educators building courses with Kudu
            were selected as AI Innovators, recognized for their work bringing
            usable, course-grounded AI into real college classrooms.
          </p>
          <p className={styles.body}>
            This is what it looks like when faculty get AI tooling that respects
            their pedagogy. Not a top-down rollout. Not a corporate platform
            announcement. Educators choosing the technology that matches their
            teaching.
          </p>

          <div className={styles.profiles}>
            <p className={styles.profileLabel}>2025 AI innovators built on Kudu</p>
            {faculty.map((profile) => (
              <FacultyProfile key={profile.name} {...profile} />
            ))}
          </div>
        </div>

        <img
          alt="ASU+GSV AI Show poster featuring three Kudu educators selected as AI Innovators."
          className={styles.image}
          loading="lazy"
          src={aiInnovatorsUrl}
        />
      </div>
    </SectionWrapper>
  );
}
